import { gql } from '@apollo/client';

const ledgerAccountFragment = gql`
  fragment LedgerParts on LedgerAccount {
    id
    name
    details
    isTemporary
    category {
      id
    }
    currencyId
    statementDayOfMonth
    accountSettings {
      collectionMethod
      optimizationStatus
      volume
      dateActive
      dateInactive
    }
    autoPostEnabled
    role
    code
    accountType
    thirdPartyLoginAvailable
    financialInstitutionProduct {
      id
      financialInstitution {
        id
        name
      }
      financialInstitutionProductType {
        id
        name
      }
    }
    isAutoGenerated
    accountLastFourDigits
  }
`;

const GET_LEDGER_OPTIONS_DATA = gql`
  query getReferenceData($clientId: ID!) {
    client(id: $clientId) {
      countryCode
      currencyId
      financialDataConnections {
        id
        source
        accounts {
          id
          ledger {
            id
          }
        }
      }
    }
    templateLedgers {
      id
      name
      code
      country {
        code
      }
    }
    currencies {
      id
      name
      code
    }
  }
`;

const GET_FINANCIAL_INSTITUTIONS = gql`
  query getFinancialInstitutions($search: String, $limit: Int) {
    financialInstitutions(query: $search, limit: $limit) {
      id
      name
      isActive
    }
  }
`;

const GET_FINANCIAL_INSTITUTION = gql`
  query getFinancialInstitution($id: ID!) {
    financialInstitution(id: $id) {
      id
      name
      plaidInstitutionId
      isActive
      products {
        id
        isActive
        financialInstitutionProductType {
          id
          name
          ledgerCategory {
            id
          }
          isDefault
        }
      }
    }
  }
`;

const GET_LEDGER_ACCOUNT = gql`
  query getLedgerAccount($ledgerId: ID!) {
    ledgerAccount(id: $ledgerId) {
      ...LedgerParts
    }
  }
  ${ledgerAccountFragment}
`;

const GET_CONNECTIONS = gql`
  query FdsConnectionCollection($clientId: ID!, $toDate: String) {
    client(id: $clientId) {
      id
      financialConnections {
        id
        financialInstitutionName
        state
        source
        institutionId
        isSyncing
        sourceId
        accounts {
          id
          name
          isPersonal
          isActive
          number
          type
          sourceSyncDateTime
          balances(toDate: $toDate, limit: 1, sortDesc: true) {
            data {
              amount
              sourceSyncTime
            }
          }
          transactions(toDate: $toDate, limit: 1, sortDesc: true) {
            data {
              date
            }
          }
          ledger {
            id
            name
            role
            latestValidBalance: balances(limit: 1, sortDesc: true, status: "VALID") {
              date
            }
            latestInvalidBalance: balances(limit: 1, sortDesc: true, status: "INVALID") {
              status
              date
            }
            referenceBalance: balances(limit: 1, sortDesc: true, status: "REFERENCE") {
              date
            }
          }
        }
      }
    }
  }
`;

export {
  ledgerAccountFragment,
  GET_LEDGER_ACCOUNT,
  GET_CONNECTIONS,
  GET_FINANCIAL_INSTITUTION,
  GET_FINANCIAL_INSTITUTIONS,
  GET_LEDGER_OPTIONS_DATA,
};
